<div class="transition-wrapper">
    <slot/>
</div>

<style lang="less" global>
    // https://github.com/sveltejs/svelte/issues/544
    // https://stackoverflow.com/a/59892853
    .transition-wrapper {
        display: grid;
        place-items: center;
        min-height: 0; /* Prevents overflow if children have intrinsic heights */
        width: 100%;
        height: 100%;

        & > * {
            grid-column: 1/2;
            grid-row: 1/2;
            min-height: 0; /* Prevents overflow if children have intrinsic heights */
        }
    }
</style>